export default __webpack_public_path__ + "static/media/replay_30.166a5736.svg";